export const rangoFechas = {
  desde: "Du",
  hasta: "Au",
  etiqueta: "Dates",
  quitar: "Effacer les dates",
  titulo: "Choisir les dates",
  elegirInicio: "Touchez le premier jour",
  elegirFin: "Touchez maintenant le dernier jour",
  dias: "jour | jours",
  anterior: "Mois précédent",
  siguiente: "Mois suivant",
  cancelar: "Annuler",
  aplicar: "Appliquer",
};
